export default __webpack_public_path__ + "static/media/piano.ebcc408a.svg";